export const testimonials = [
  {
    id: 't1',
    name: '张伟',
    role: '某科技公司CEO',
    content: '开云平台帮助我们实现了业务流程的全面数字化，团队协作效率提升了至少50%。强烈推荐给每一个追求效率的团队。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%2C%20warm%20lighting%2C%20simple%20beige%20background%2C%20friendly%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=kaiyun-testimonial-1&orientation=squarish',
  },
  {
    id: 't2',
    name: '李婷',
    role: '某电商平台运营总监',
    content: '自从使用开云平台以来，我们的数据分析能力得到了质的飞跃。智能推荐功能让用户留存率提升了35%，这远超我们的预期。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%2C%20warm%20natural%20light%2C%20simple%20cream%20background%2C%20confident%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=kaiyun-testimonial-2&orientation=squarish',
  },
  {
    id: 't3',
    name: '王磊',
    role: '某金融机构技术负责人',
    content: '开云的安全防护体系让我们非常放心。多层加密和实时监控功能确保了金融数据的绝对安全，完全符合行业合规要求。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%2C%20warm%20studio%20lighting%2C%20simple%20beige%20background%2C%20serious%20professional%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=kaiyun-testimonial-3&orientation=squarish',
  },
  {
    id: 't4',
    name: '陈雪',
    role: '某教育机构创始人',
    content: '开云平台的协同办公功能让我们的远程教学管理变得异常简单。教师和学生的互动效率大幅提升，家长满意度也显著提高。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%2C%20soft%20warm%20lighting%2C%20simple%20cream%20background%2C%20warm%20smile%2C%20corporate%20headshot%20style&width=120&height=120&seq=kaiyun-testimonial-4&orientation=squarish',
  },
];

export const brandMilestones = [
  { year: '2018', title: '品牌创立', description: '开云平台正式成立，致力于为企业提供数字化解决方案。' },
  { year: '2019', title: '产品上线', description: '开云平台1.0版本正式发布，首批企业用户入驻。' },
  { year: '2020', title: '用户突破', description: '平台注册用户突破10万，服务覆盖全国主要城市。' },
  { year: '2021', title: '技术升级', description: '完成AI智能引擎升级，推出智能推荐与数据分析功能。' },
  { year: '2022', title: '生态构建', description: '开放平台API，与超过200家合作伙伴建立生态联盟。' },
  { year: '2023', title: '行业领先', description: '荣获行业最佳数字化平台奖，用户数突破50万。' },
  { year: '2024', title: '全球拓展', description: '启动国际化战略，业务拓展至东南亚及欧洲市场。' },
  { year: '2025', title: '智能升级', description: '发布开云AI 2.0，深度融合大语言模型与业务场景。' },
  { year: '2026', title: '全新启航', description: '开云平台全新改版，以更优质的服务迎接每一位用户。' },
];

export const contactInfo = {
  address: '北京市朝阳区建国路88号开云大厦',
  phone: '400-888-6666',
  email: 'contact@kaiyun.com',
  workingHours: '周一至周五 09:00 - 18:00',
};